import { TemaCard } from 'src/data/models/TemaCardModel';

export const relationshipCards: TemaCard[] = [
    // 💬 Phrases to Get to Know Someone
    new TemaCard(
        'relationship1',
        'Relationships',
        'sentence',
        '¿Qué te gusta hacer en tu tiempo libre?',
        'What do you like to do in your free time?',
        'A great way to start a conversation and learn about someone’s interests.'
    ),
    new TemaCard(
        'relationship2',
        'Relationships',
        'sentence',
        '¿Qué tipo de música escuchas?',
        'What kind of music do you listen to?',
        'To learn about someone’s taste in music.'
    ),
    new TemaCard(
        'relationship3',
        'Relationships',
        'sentence',
        '¿Tienes algún pasatiempo favorito?',
        'Do you have a favorite hobby?',
        'A good question to ask about hobbies and interests.'
    ),
    new TemaCard(
        'relationship4',
        'Relationships',
        'sentence',
        '¿Cuál ha sido tu viaje favorito?',
        'What has been your favorite trip?',
        'A way to learn about someone’s travel experiences.'
    ),
    new TemaCard(
        'relationship5',
        'Relationships',
        'sentence',
        '¿Qué te apasiona en la vida?',
        'What are you passionate about in life?',
        'A deeper question to understand someone’s core passions.'
    ),
    new TemaCard(
        'relationship6',
        'Relationships',
        'sentence',
        '¿Prefieres planes tranquilos o aventureros?',
        'Do you prefer chill plans or adventurous ones?',
        'To learn about someone’s activity preferences.'
    ),
    new TemaCard(
        'relationship7',
        'Relationships',
        'sentence',
        '¿Qué te hace reír?',
        'What makes you laugh?',
        'A fun question to get to know what brings joy to someone.'
    ),
    new TemaCard(
        'relationship8',
        'Relationships',
        'sentence',
        '¿Qué es lo más importante en una amistad?',
        'What’s most important to you in a friendship?',
        'A great way to understand someone’s values regarding friendship.'
    ),

    // 🎨 Related Words – Hobbies / Interests
    new TemaCard(
        'relationship9',
        'Relationships',
        'word',
        'pasatiempo',
        'hobby',
        'A general term for activities done in leisure time.',
        [
            { spanish: 'dibujar', english: 'to draw' },
            { spanish: 'leer', english: 'to read' },
            { spanish: 'cocinar', english: 'to cook' },
            { spanish: 'viajar', english: 'to travel' },
            { spanish: 'bailar', english: 'to dance' },
            { spanish: 'tocar un instrumento', english: 'to play an instrument' },
            { spanish: 'jugar videojuegos', english: 'to play video games' },
            { spanish: 'hacer senderismo', english: 'to go hiking' },
        ]
    ),

    // 🧑‍🤝‍🧑 Related Words – Friendship
    new TemaCard(
        'relationship10',
        'Relationships',
        'word',
        'amigo/a',
        'friend',
        'A general term for a friend.',
        [
            { spanish: 'mejor amigo/a', english: 'best friend' },
            { spanish: 'compañero/a', english: 'companion' },
            { spanish: 'confianza', english: 'trust' },
            { spanish: 'apoyo', english: 'support' },
            { spanish: 'lealtad', english: 'loyalty' },
            { spanish: 'bromear', english: 'to joke' },
            { spanish: 'pasar tiempo juntos', english: 'to spend time together' },
        ]
    ),

    // ❤️ Related Words – Dating / Romance
    new TemaCard(
        'relationship11',
        'Relationships',
        'word',
        'cita',
        'date',
        'A term for a date, romantic outing.',
        [
            { spanish: 'pareja', english: 'partner' },
            { spanish: 'amor', english: 'love' },
            { spanish: 'atracción', english: 'attraction' },
            { spanish: 'química', english: 'chemistry' },
            { spanish: 'coqueteo', english: 'flirting' },
            { spanish: 'relación seria', english: 'serious relationship' },
            { spanish: 'compromiso', english: 'commitment' },
        ]
    ),

    // 😌 Related Words – Emotional States
    new TemaCard(
        'relationship12',
        'Relationships',
        'word',
        'feliz',
        'happy',
        'General term for feeling happy.',
        [
            { spanish: 'emocionado/a', english: 'excited' },
            { spanish: 'nervioso/a', english: 'nervous' },
            { spanish: 'tranquilo/a', english: 'calm' },
            { spanish: 'triste', english: 'sad' },
            { spanish: 'ansioso/a', english: 'anxious' },
            { spanish: 'enamorado/a', english: 'in love' },
            { spanish: 'confundido/a', english: 'confused' },
            { spanish: 'seguro/a', english: 'secure/confident' },
        ]
    ),
];
